<div class="h-100 box d-flex flex-column px-2 pb-5">
    <div class="px-4">
        <div class="text-l font-semi-bold border-b border-dark py-5">{{ 'v3-byoc-popup-create-episode-title' | translate }}</div>
    </div>

    <div class="flex-grow-1">
        <div class="py-4 px-4 relative inner">
            <div class="text-uppercase font-semi-bold text-default text-s mb-4" translate>v3-byoc-popup-create-episode-course-title</div>

            <div class="mb-4" elementDataTest="searchInput">
                <app-forms-input
                    [control]="searchFormControl"
                    icon="lens"
                    classes="info"
                    [placeholder]="'v3-byoc-popup-create-episode-course-input-placeholder' | translate"
                ></app-forms-input>
            </div>

            <div class="d-flex align-items-center mb-4">
                <div class="me-4">
                    <!-- Radio -->
                    <div class="radio radio-success">
                        <input id="form-radio-origin-0" type="radio" [formControl]="originControl" [value]="0" name="form-radio-origin" />
                        <label for="form-radio-origin-0" class="text-odd-xxs text-uppercase">
                            {{ 'v3-global-all' | translate }}
                            <span class="icon" [inlineSVG]="'assets/icons.svg#dot'"></span>
                        </label>
                    </div>
                </div>
                <div class="me-4">
                    <!-- Radio -->
                    <div class="radio radio-success">
                        <input id="form-radio-origin-1" type="radio" [formControl]="originControl" [value]="1" name="form-radio-origin" />
                        <label for="form-radio-origin-1" class="text-odd-xxs text-uppercase">
                            {{ 'v3-byoc-popup-create-episode-course-radio-st-courses' | translate }}
                            <span class="icon" [inlineSVG]="'assets/icons.svg#dot'"></span>
                        </label>
                    </div>
                </div>
                <div>
                    <!-- Radio -->
                    <div class="radio radio-success">
                        <input id="form-radio-origin-2" type="radio" [formControl]="originControl" [value]="2" name="form-radio-origin" />
                        <label for="form-radio-origin-2" class="text-odd-xxs text-uppercase">
                            {{ 'v3-byoc-popup-create-episode-course-radio-custom-courses' | translate }}
                            <span class="icon" [inlineSVG]="'assets/icons.svg#dot'"></span>
                        </label>
                    </div>
                </div>
            </div>

            <app-byoc-episode-step-course-list
                #coursesList
                [searchFormControl]="searchFormControl"
                [originControl]="originControl"
            ></app-byoc-episode-step-course-list>
        </div>
    </div>

    <div class="theme-new d-flex align-items-center px-4 flex-wrap justify-content-end">
        <button (click)="cancelClick()" class="btn btn-primary ms-auto mb-1" buttonDataTest="cancelButton" translate>v3-button-cancel</button>
        <button (click)="backClick()" class="btn btn-primary mb-1" buttonDataTest="backButton" translate>v3-button-back</button>

        <ng-container *ngIf="!isSelectedCourseEmpty || !isCourseSelected; else emptyCourseButtons">
            <button
                [disabled]="!courseIdControl.valid || processing"
                (click)="nextClick()"
                buttonDataTest="continueButton"
                class="btn o-hidden mb-1"
                [ngClass]="[courseIdControl.valid && !processing ? 'btn-secondary' : 'btn-disabled']"
            >
                <span translate>v3-button-continue</span>
                <app-loader *ngIf="processing" loaderType="button" loaderColor="white" overlayColor="info"></app-loader>
            </button>
        </ng-container>
    </div>
</div>

<ng-template #emptyCourseButtons>
    <button
        (click)="saveAsDraftClick()"
        [disabled]="!courseIdControl.valid || processing"
        class="btn o-hidden mb-1"
        buttonDataTest="saveAsDraftButton"
        [ngClass]="[!processing ? 'btn-secondary' : 'btn-disabled']"
    >
        <span translate>v3-button-save-as-draft</span>
        <app-loader *ngIf="processing" loaderType="button" loaderColor="default" overlayColor="white"></app-loader>
    </button>
    <button
        (click)="usersClick()"
        [disabled]="!courseIdControl.valid || processing"
        buttonDataTest="publishButton"
        class="btn o-hidden mb-1"
        [ngClass]="[!processing ? 'btn-secondary' : 'btn-disabled']"
    >
        <span translate>v3-button-publish</span>
        <app-loader *ngIf="processing" loaderType="button" loaderColor="white" overlayColor="info"></app-loader>
    </button>
</ng-template>
